/* this file is transformed by vux-loader */
/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import state from "./state";
import * as getters from "./getters";
import * as actions from "./actions";
import mutations from "./mutations";
import profile from "./modules/profile";
import contact from "./modules/contact";
import * as types from "./mutation-types";
Vue.use(Vuex);
var store = new Vuex.Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  modules: {
    profile: profile,
    contact: contact
  }
});
store.types = types;
export { types };
export default store;